import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  // providers are definined in the service's metadata
})
export class FormServicesModule {}
